import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-angular';

export const locale = 'nl-NL';

I18n.putVocabularies(translations);
I18n.setLanguage('nl');

I18n.putVocabulariesForLanguage('nl', {
  'Sign in': 'Aanmelden',
  'Email': 'E-mailadres *',
  'Password': 'Wachtwoord *',
  'Enter your Email': 'Voer je e-mailadres in',
  'Enter your email': 'Voer je e-mailadres in',
  'Enter your Password': 'Voer je wachtwoord in',
  'Reset Password': 'Hersel je wachtwoord',
  'Back to Sign In': 'Terug naar aanmelden',
  'Send code': 'Code versturen',
  'Code': 'Verificatiecode',
  'Invalid verification code provided, please try again.': 'Verificatiecode is ongeldig.',
  'New Password': 'Voer je nieuw wachtwoord in',
  'Confirm Password': 'Bevestig je wachtwoord',
  'Submit': 'Bevestigen',
  'Change Password': 'Wachtwoord wijzigen',
  'Username cannot be empty': 'E-mailadres mag niet leeg zijn',
  'Incorrect username or password.': 'Ongeldig e-mailadres of wachtwoord',
  'Custom auth lambda trigger is not configured for the user pool.': 'Ongeldig e-mailadres of wachtwoord',

  'Password does not conform to policy: Password not long enough': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
  'Password does not conform to policy: Password must have lowercase characters': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
  'Password does not conform to policy: Password must have uppercase characters': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
  'Password does not conform to policy: Password must have numeric characters': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
  'Password does not conform to policy: Password must have symbol characters': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
  'Attempt limit exceeded, please try after some time.': 'Te veel wachtwoord herstel pogingen, probeer het later opnieuw',
  '2 validation errors detected: Value at \'password\' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\S]+.*[\S]+$; Value at \'password\' failed to satisfy constraint: Member must have length greater than or equal to 6': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
  '1 validation error detected: Value at \'password\' failed to satisfy constraint: Member must have length greater than or equal to 6': 'Wachtwoord moet minstens 8 karakters zijn, waarvan minstens 1 hoofdletter en minstens 1 cijfer',
});
